/**
 * Tutoring Schedule Workflow Machine Config
 *
 * Domain: Tutoring > Schedule
 * Description: State machine for tutoring schedule lifecycle.
 * States: draft → proposed → accepted/rejected → active → completed/cancelled
 */
export const tutoringScheduleConfig = {
    id: 'tutoring-schedule',
    initial: 'draft',
    states: {
        draft: {
            on: { PROPOSE: { target: 'proposed', guard: 'hasScheduleDetails' } },
        },
        proposed: {
            on: {
                ACCEPT: 'accepted',
                REJECT: { target: 'rejected', guard: 'hasRejectionReason' },
            },
        },
        accepted: {
            on: { ACTIVATE: { target: 'active', guard: 'isWithinEffectivePeriod' } },
        },
        rejected: {
            type: 'final',
        },
        active: {
            on: {
                COMPLETE: 'completed',
                CANCEL: { target: 'cancelled', guard: 'hasCancellationReason' },
            },
        },
        completed: {
            type: 'final',
        },
        cancelled: {
            type: 'final',
        },
    },
};
//# sourceMappingURL=tutoring-schedule.js.map